/**
 * Resolves the listing-alias filter to send to the lead-management endpoints: the multi-listing
 * array when non-empty, otherwise the single alias, otherwise empty (no filter / all listings).
 * Shared so the table query and the search bar stay in sync on this precedence.
 */
export default function resolveListingAliases(
  listingAlias?: string | null,
  listingAliases?: Array<string>,
): Array<string> {
  if (listingAliases?.length) return listingAliases;
  if (listingAlias) return [listingAlias];
  return [];
}
